// components/ui/BookingButton.jsx
'use client';

import Link from 'next/link';

export default function BookingButton({ children, className = '', ...props }) {
  return (
    <Link
      href="/book-now"
      className={`bg-primary border-primary text-primary-foreground inline-flex items-center justify-center rounded px-4 py-2.5 text-sm font-semibold uppercase shadow transition hover:shadow-md hover:brightness-90 ${className}`}
      {...props}
    >
      {children}
    </Link>
  );
}
